export const role = {
    ADMIN: "admin",
    STAFF: "staff",
    CUSTOMER: "customer"
}

export const updateTourOrderType = {
    CANCEL: "cancel",
    REORDER: "reOrder",
    UPDATE: "update"
}